import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { AbschlussSeiteHochladeFeldBox, FinaleSchritteInfoBoxAbschlussbericht } from '../../../../antrag-components/AbschlussSeiteBox';
import HinweisAnDieHaFeld from '../../../../antrag-components/HinweisAnDieHAFeld';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const AbschlussAbschlussEmobInvest: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Abschluss" description={PLATZHALTER_TEXT} />

			<FinaleSchritteInfoBoxAbschlussbericht />
			<AbschlussSeiteHochladeFeldBox>
				<CreateForm formStruc={formStrucUpload()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
			</AbschlussSeiteHochladeFeldBox>

			<HinweisAnDieHaFeld />
		</>
	);
};

export default AbschlussAbschlussEmobInvest;

const formStrucUpload = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Allgemein_Eingereichter_Abschlussbericht],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucAbschlussAbschlussEmobInvest = () => {
	return concat(formStrucUpload());
};
